import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./Navbar.css";
import logo from "../../assets/logo2.png";

function Navbarr() {
  return (
    <div>
      <Navbar className="nav-container">
        <Container>
          <Nav className="links ">
            <Nav.Link className="nav-color" href="#home">
              HEM
            </Nav.Link>
            <Nav.Link className="nav-color" href="#about">
              OM OSS
            </Nav.Link>
            <Nav.Link className="nav-color" href="#services">
              TJÄNSTER
            </Nav.Link>
          </Nav>
          <img className="logo-nav" src={logo} alt="" />
        </Container>
      </Navbar>
    </div>
  );
}

export default Navbarr;
